import React, {useState} from 'react'
import {createSupplier} from "../../services/serviceSupplier";
import {Button, Form, Input, Modal} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const { TextArea } = Input
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}


const SupplierCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [loadings, setLoadings] = useState([])


    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            name: list.supplierName,
            code: list.supplierCode,
            description: list.supplierDescription,
            phone: list.supplierPhone,
            email: list.supplierEmail,
            address: list.supplierAddress
        }
        createSupplier(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Modal
                open={show}
                onCancel={modalCloser}
                title={'Yeni Kategori Ekle'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            onClick={() => form.submit()}
                            loading={loadings[0]}
                    >Kaydet</Button>,
                    <Button  key={'CancelButton'} onClick={() => modalCloser()} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >

                    <Form.Item
                        label={'Tedarikçi Adı'}
                        name={'supplierName'}
                        rules={[
                            {required:true, message: 'Tedarikçi Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Tedarikçi Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Kodu'}
                        name={'supplierCode'}
                        rules={[
                            {required: true, message: 'Tedarikçi Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Tedarikçi Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 50, message: 'Tedarikçi Kodu En az 3 En Fazla 20 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Açıklaması'}
                        name={'supplierDescription'}
                        rules={[
                            {min:1, max:1000, message: 'Açıklama Alanı En Az 1 En Fazla 1000 Karakter Olmalı'}
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Telefonu'}
                        name={'supplierPhone'}
                        rules={[
                            {max: 20, message: 'Telefon Alanı En Fazla 20 Karakter Olmalı'},
                            {pattern: /^\d*$/, message: 'Tedarikçi Telefonu Sadece Rakam İçermelidir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Email'}
                        name={'supplierEmail'}
                        rules={[
                            {type: 'email', message: 'Doğru Bir E-mail Formatı Giriniz (örnek@örnek.com)'},
                            {max: 100, message: 'E-mail alanı En Fazla 100 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Adress'}
                        name={'supplierAddress'}
                        rules={[
                            {max: 1000, message: 'Adres Alanı En Fazla 1000 Karakter Olmalı'}
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default  SupplierCreate